// src/helpers/rutaOrdenesPago.js
import axios from "axios";

const BASE_URL = "https://backsanpancracio.us-3.evennode.com"; // prod
const API_BASE = process.env.REACT_APP_API || BASE_URL;

// Axios instance
const api = axios.create({
  baseURL: API_BASE,
  timeout: 15000,
});

// Inyecta token automáticamente
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token") || "";
  if (token) config.headers.token = token; // tu backend usa 'token'
  return config;
});

// Normaliza error (cubre msg | err | error | message)
const parseErr = (e) =>
  e?.response?.data?.msg ??
  e?.response?.data?.err ??
  e?.response?.data?.error ??
  e?.response?.data?.message ??
  e?.message ??
  "Error desconocido";

// *** IMPORTANTE: path en SINGULAR (coincide con tu back) ***
const PATH = "/ordenpago";

/** Crea una Orden de Pago */
export const postOrdenPago = async (payload) => {
  try {
    const { data } = await api.post(PATH, payload, {
      headers: { "Content-Type": "application/json" },
    });
    return data; // { ok, orden }
  } catch (e) {
    return { ok: false, msg: parseErr(e) };
  }
};

/** Trae una OP por id (populada en back) */
export const getOrdenPago = async (id) => {
  try {
    const { data } = await api.get(`${PATH}/${id}`);
    return data; // { ok, orden }
  } catch (e) {
    return { ok: false, msg: parseErr(e) };
  }
};

/** Lista OP con filtros opcionales: {tercero, cliente, desde, hasta} */
export const listOrdenesPago = async (params = {}) => {
  try {
    const { data } = await api.get(PATH, { params });
    return data; // { ok, ordenes }
  } catch (e) {
    return { ok: false, msg: parseErr(e) };
  }
};

/** Anula una OP y revierte aplicaciones (y, si corresponde, saldos/movs) */
export const anularOrdenPago = async (id) => {
  try {
    const { data } = await api.post(`${PATH}/${id}/anular`, {});
    return data; // { ok, orden, warns? }
  } catch (e) {
    return { ok: false, msg: parseErr(e) };
  }
};

export default {
  postOrdenPago,
  getOrdenPago,
  listOrdenesPago,
  anularOrdenPago,
}